import { ChangeDetectionStrategy, Component, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { ScreenUtilsService } from 'core/services';
import { FixedScrollService } from 'core/shared-components';
import { SidenavService } from './sidenav.service';

@Component({
  selector: 'ss-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],

  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidenavComponent {

  @ViewChildren('mobileToolbar', { read: ElementRef })
  private readonly _mobileToolbarQL: QueryList<ElementRef<HTMLElement>>

  readonly expandedSubject = this._sidenavService.expandedSubject;
  get expanded() {
    return this.expandedSubject.value;
  }


  readonly mobileToolbarTemplateRefSubject = this._sidenavService.mobileToolbarTemplateRefSubject
  readonly rotateObs = this._sidenavService.rotateObs;
  readonly widthObs = this._sidenavService.widthObs;
  readonly contentWidthObs = this._sidenavService.contentWidthObs;
  readonly openedSubject = this._sidenavService.openedSubject;
  readonly marginLeftObs = this._sidenavService.marginLeftObs;
  readonly modeSubject = this._sidenavService.modeSubject;
  readonly isSmallerScreenObs = this._screenUtilsService.isSmallerScreenObs
  readonly showMobileToolbarObs = this._sidenavService.showMobileToolbarObs;

  constructor(
    private readonly _sidenavService: SidenavService,
    private readonly _screenUtilsService: ScreenUtilsService,
    private readonly _fixedScrollService: FixedScrollService
  ) {

  }


  ngAfterViewInit() {
    // this._mobileToolbarQL.changes.pipe(
    //   startWith(this._mobileToolbarQL),
    //   map((mobileToolbarQL: QueryList<ElementRef<HTMLElement>>) => mobileToolbarQL.first),
    //   distinctUntilChanged()
    // )
    //   .subscribe((elementRef) => {
    //     if (!elementRef) {
    //       this._fixedScrollService.otherElementsSubject.next(null);
    //       return;
    //     }
    //     this._fixedScrollService.otherElementsSubject.next([elementRef.nativeElement])
    //   })
  }


  toggleExpanded() {
    this._sidenavService.toggleExpanded();
  }

}
